
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/medical-card/illinois",
      function () {
        return require("private-next-pages/medical-card/illinois.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/medical-card/illinois"])
      });
    }
  